import React, { useEffect, useState } from 'react';
import LightningIcon from '../../../assets/img/lightning.png';
import BarChartComponent from '../../../components/Charts/BarChart';
import { useNavigate } from 'react-router-dom';
import EmptyState from '../../../components/EmptyState';

const AssetBreakdown = (props) => {
  const { chain_asset_breakdown, available_chains, direction } = props;
  const navigate = useNavigate();
  const [assets, setAssets] = useState([]);

  const handleNavigate = () => {
    if (props.individualPage) {
      props.navigatedTab(4);
    } else {
      navigate('/assets');
    }
  };

  useEffect(() => {
    if (chain_asset_breakdown && chain_asset_breakdown.length > 0) {
      setAssets(chain_asset_breakdown);
    }
  }, [chain_asset_breakdown]);

  return (
    <>
      <div className="home_card" style={{ minHeight: '405px', position: 'relative' }}>
        <div>
          <div>
            <span className="heading_text">{props.title ? props.title : 'Asset Breakdown'}</span>
            {props.lightningIcon && (
              <span
                style={{
                  float: 'right',
                  color: '#0070D2',
                  fontWeight: 400,
                  fontSize: 13,
                  border: '1px solid blue',
                  padding: '7px 12px',
                  borderRadius: '5px',
                }}
              >
                Pie Chart &nbsp;
                <img src={LightningIcon} alt="lightningIcon" />
              </span>
            )}
          </div>
          <div style={{ marginTop: '1rem', marginBottom: '1.4rem' }}>
            {assets && assets.length && available_chains.length ? (
              <BarChartComponent data={assets} chains={available_chains} direction={direction} />
            ) : (
              <EmptyState />
            )}
          </div>
        </div>
        {props.individualPage && (
          <div
            className="view-assets"
            style={{ color: '#006DCC', cursor: 'pointer' }}
            onClick={handleNavigate}
          >
            View All Assets
          </div>
        )}
      </div>
    </>
  );
};

export default AssetBreakdown;
